import { getToken } from "../Common/utils/auth";
import { BASE_URL } from "../Common/constant";
import axios from "axios";

export const addUser = async (userData: any) => {
    try {
        const result = await axios.post(BASE_URL + "user/add", userData, {
            headers: {
                encryption: false,
            }
        });
        return result.data;
    } catch (error) {
        console.error("Error adding user:", error);
        throw error;
    }
};

export const blockUser = async (email: string) => {
    try {
        const result = await axios.post(BASE_URL + "user/block", { "email": email }, {
            headers: {
                encryption: false,
                token: getToken()
            }
        });
        return result.data;
    } catch (error) {
        console.error("Error blocking user:", error);
        throw error;
    }
};

export const updateUserRole = async (email: string, role: string) => {
    try {
        const result = await axios.post(BASE_URL + "user/roleupdate", {
            "email": email,
            "role": role
        }, {
            headers: {
                encryption: false,
                token: getToken()
            }
        });
        return result.data;
    } catch (error) {
        console.error("Error updating user role:", error);
        throw error;
    }
};

export const getAllUsers = async () => {
    try {
        const result = await axios.get(BASE_URL + "user/getall", {
            headers: {
                encryption: false,
                token: getToken()
            }
        });
        return result.data.data;
    } catch (error) {
        console.error("Error fetching all users:", error);
        throw error;
    }
};